<template>
  <div v-if="rendered" class="seg-root">
    <!-- HEADER -->
    <div class="seg-header">
      <div class="seg-header-left">
        <div class="seg-header-icon">
          <svg
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2.2"
          >
            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
            <circle cx="9" cy="7" r="4" />
            <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
            <path d="M16 3.13a4 4 0 0 1 0 7.75" />
          </svg>
        </div>
        <div>
          <h1 class="seg-title">Grupos de Clientes</h1>
          <p class="seg-sub">
            {{ filtros_utilizador.length }} grupo{{
              filtros_utilizador.length !== 1 ? "s" : ""
            }}
            guardado{{ filtros_utilizador.length !== 1 ? "s" : "" }}
          </p>
        </div>
      </div>
      <button class="seg-create-btn" @click="abrirCriarFiltro">
        <svg
          width="14"
          height="14"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2.5"
        >
          <path d="M12 5v14M5 12h14" />
        </svg>
        Criar grupo
      </button>
    </div>

    <!-- EMPTY STATE -->
    <div v-if="filtros_utilizador.length === 0" class="seg-empty">
      <div class="seg-empty-icon">
        <svg
          width="36"
          height="36"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="1.5"
        >
          <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
          <circle cx="9" cy="7" r="4" />
          <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
          <path d="M16 3.13a4 4 0 0 1 0 7.75" />
        </svg>
      </div>
      <h3>Nenhum grupo criado</h3>
      <p>Cria um grupo de clientes para segmentar campanhas e insights.</p>
      <button class="seg-create-btn" @click="abrirCriarFiltro">
        <svg
          width="14"
          height="14"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2.5"
        >
          <path d="M12 5v14M5 12h14" />
        </svg>
        Criar primeiro grupo
      </button>
    </div>

    <!-- GRID DE CARDS -->
    <div class="seg-grid">
      <div
        v-for="(filtro, index) in filtros_utilizador"
        :key="index"
        class="seg-card"
      >
        <!-- Topo do card -->
        <div class="seg-card-top">
          <div class="seg-card-header">
            <h3 class="seg-card-name">{{ filtro.nome }}</h3>
            <button
              class="seg-delete-btn"
              @click="removerFiltro(filtro)"
              title="Eliminar grupo"
            >
              <svg
                width="13"
                height="13"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2.5"
              >
                <polyline points="3 6 5 6 21 6" />
                <path d="M19 6l-1 14H6L5 6" />
                <path d="M10 11v6M14 11v6" />
                <path d="M9 6V4h6v2" />
              </svg>
            </button>
          </div>

          <!-- Número de clientes (destaque) -->
          <div class="seg-count-row">
            <span class="seg-count">{{
              filtro.clientes.toLocaleString("pt-PT")
            }}</span>
            <span class="seg-count-label">clientes</span>
          </div>

          <!-- Descrição -->
          <p v-if="filtro.descricao" class="seg-desc">{{ filtro.descricao }}</p>

          <!-- Preview das condições -->
          <div class="seg-chips" v-if="getChips(filtro).length">
            <span
              v-for="(chip, i) in getChips(filtro).slice(0, 3)"
              :key="i"
              class="seg-chip"
              >{{ chip }}</span
            >
            <span
              v-if="getChips(filtro).length > 3"
              class="seg-chip seg-chip-more"
            >
              +{{ getChips(filtro).length - 3 }}
            </span>
          </div>
        </div>

        <!-- Separador -->
        <div class="seg-card-divider"></div>

        <!-- Ações -->
        <div class="seg-card-actions">
          <button class="seg-action" @click="verClientes(filtro)">
            <svg
              width="13"
              height="13"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
            >
              <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
              <circle cx="9" cy="7" r="4" />
            </svg>
            Clientes
          </button>
          <button class="seg-action" @click="verInsights(filtro)">
            <svg
              width="13"
              height="13"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
            >
              <polyline points="22 12 18 12 15 21 9 3 6 12 2 12" />
            </svg>
            Insights
          </button>
          <button
            v-if="!isStaff"
            class="seg-action"
            @click="enviarCampanha(filtro)"
          >
            <svg
              width="13"
              height="13"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
            >
              <line x1="22" y1="2" x2="11" y2="13" />
              <polygon points="22 2 15 22 11 13 2 9 22 2" />
            </svg>
            Campanha
          </button>
          <button
            class="seg-action seg-action-details"
            @click="mostrarDetalhesFiltro(filtro)"
          >
            <svg
              width="13"
              height="13"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
            >
              <circle cx="12" cy="12" r="10" />
              <path d="M12 8v4M12 16h.01" />
            </svg>
            Detalhes
          </button>
        </div>
      </div>
    </div>

    <!-- MODAL DETALHES -->
    <transition name="seg-fade">
      <div
        v-if="modalDetalhes"
        class="seg-overlay"
        @click.self="modalDetalhes = false"
      >
        <div class="seg-modal">
          <div class="seg-modal-head">
            <div>
              <div class="seg-modal-title">
                {{ filtroAtivo && filtroAtivo.nome }}
              </div>
              <div class="seg-modal-sub">
                {{
                  filtroAtivo && filtroAtivo.clientes.toLocaleString("pt-PT")
                }}
                clientes correspondem a este grupo
              </div>
            </div>
            <button class="seg-modal-close" @click="modalDetalhes = false">
              <svg
                width="14"
                height="14"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2.5"
              >
                <path d="M18 6 6 18M6 6l12 12" />
              </svg>
            </button>
          </div>

          <div class="seg-modal-body">
            <div v-if="filtroDetalhesFormatado.length">
              <p class="seg-modal-section-title">Condições do grupo</p>
              <div class="seg-modal-chips">
                <div
                  v-for="(linha, i) in filtroDetalhesFormatado"
                  :key="i"
                  class="seg-modal-chip"
                >
                  <svg
                    width="12"
                    height="12"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2.5"
                  >
                    <path d="M20 6 9 17l-5-5" />
                  </svg>
                  {{ linha }}
                </div>
              </div>
            </div>
            <div v-else class="seg-modal-empty">
              <p>
                Este grupo não tem condições específicas — inclui todos os
                clientes.
              </p>
            </div>
          </div>

          <div class="seg-modal-foot">
            <button
              class="seg-btn seg-btn-ghost"
              @click="modalDetalhes = false"
            >
              Fechar
            </button>
            <button
              v-if="!isStaff"
              class="seg-btn seg-btn-primary"
              @click="
                enviarCampanha(filtroAtivo);
                modalDetalhes = false;
              "
            >
              <svg
                width="13"
                height="13"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2.5"
              >
                <line x1="22" y1="2" x2="11" y2="13" />
                <polygon points="22 2 15 22 11 13 2 9 22 2" />
              </svg>
              Enviar campanha
            </button>
          </div>
        </div>
      </div>
    </transition>
  </div>
  <LoadingOverlay v-else />
</template>

<script>
  import { filtrosService } from "@/services";
  import LoadingOverlay from "@/components/Loading/LoadingOverlay";
  import swal from "sweetalert2";

  const MAPA_DATAS = {
    "3d": "últimos 3 dias",
    "1s": "última semana",
    "2s": "últimas 2 semanas",
    "1m": "último mês",
    "2m": "últimos 2 meses",
    "3m": "últimos 3 meses",
    "6m": "últimos 6 meses",
  };

  export default {
    components: { LoadingOverlay },
    computed: {
      isStaff() {
        return (
          JSON.parse(localStorage.getItem("user") || "{}").role === "staff"
        );
      },
    },
    data() {
      return {
        rendered: false,
        filtros_utilizador: [],
        modalDetalhes: false,
        filtroAtivo: null,
        filtroDetalhesFormatado: [],
      };
    },
    methods: {
      getChips(filtro) {
        try {
          const json = JSON.parse(filtro.filtro_json);
          const chips = [];
          if (json.restaurante?.length)
            chips.push(
              `${json.restaurante.length} restaurante${
                json.restaurante.length > 1 ? "s" : ""
              }`,
            );
          if (json.genero?.length) chips.push(json.genero.join(", "));
          if (json.idade?.length) chips.push(json.idade.join(", ") + " anos");
          if (json.estado?.length) chips.push(json.estado.join(", "));
          if (json.data_ultima_visita && json.data_ultima_visita !== "0")
            chips.push("Visita: " + MAPA_DATAS[json.data_ultima_visita]);
          if (json.data_sem_visitar && json.data_sem_visitar !== "0")
            chips.push("Ausente: " + MAPA_DATAS[json.data_sem_visitar]);
          if (json.total_visitas_de)
            chips.push(`≥ ${json.total_visitas_de} visitas`);
          if (json.total_gasto_min)
            chips.push(`≥ ${json.total_gasto_min}€ gasto`);
          if (json.produtos?.filter((p) => p.nome?.trim()).length)
            chips.push(
              `${
                json.produtos.filter((p) => p.nome?.trim()).length
              } produto(s)`,
            );
          return chips;
        } catch {
          return [];
        }
      },

      mostrarDetalhesFiltro(filtro) {
        try {
          const json = JSON.parse(filtro.filtro_json);
          const linhas = [];
          if (json.restaurante?.length)
            linhas.push(`Restaurantes: ${json.restaurante.join(", ")}`);
          if (json.genero?.length)
            linhas.push(`Género: ${json.genero.join(", ")}`);
          if (json.idade?.length)
            linhas.push(`Faixa etária: ${json.idade.join(", ")}`);
          if (json.estado?.length)
            linhas.push(`Estado: ${json.estado.join(", ")}`);
          if (json.data_ultima_visita && json.data_ultima_visita !== "0")
            linhas.push(
              `Última visita: ${MAPA_DATAS[json.data_ultima_visita]}`,
            );
          if (json.data_sem_visitar && json.data_sem_visitar !== "0")
            linhas.push(`Sem visitar há: ${MAPA_DATAS[json.data_sem_visitar]}`);
          if (json.data_inscricao && json.data_inscricao !== "0")
            linhas.push(`Inscrição: ${MAPA_DATAS[json.data_inscricao]}`);
          if (json.total_visitas_de)
            linhas.push(`Visitas mínimas: ${json.total_visitas_de}`);
          if (json.total_visitas_ate)
            linhas.push(`Visitas máximas: ${json.total_visitas_ate}`);
          if (json.total_gasto_min)
            linhas.push(`Gasto mínimo: ${json.total_gasto_min}€`);
          if (json.total_gasto_max)
            linhas.push(`Gasto máximo: ${json.total_gasto_max}€`);
          if (json.ticket_medio_min)
            linhas.push(`Ticket médio mínimo: ${json.ticket_medio_min}€`);
          if (json.ticket_medio_max)
            linhas.push(`Ticket médio máximo: ${json.ticket_medio_max}€`);
          if (Array.isArray(json.produtos)) {
            json.produtos
              .filter((p) => p.nome?.trim())
              .forEach((p) => {
                linhas.push(
                  `Produto: "${p.nome}" — pelo menos ${p.vezes ?? 1} vez(es)`,
                );
              });
          }
          if (json.consumoRestaurantes) {
            json.consumoRestaurantes.forEach((c) => {
              if (c.restaurante && c.vezes != null) {
                linhas.push(
                  c.vezes === 0
                    ? `Nunca visitou: ${c.restaurante}`
                    : `Visitou ${c.restaurante} ≥ ${c.vezes} vez(es)`,
                );
              }
            });
          }
          this.filtroDetalhesFormatado = linhas;
          this.filtroAtivo = filtro;
          this.modalDetalhes = true;
        } catch (e) {
          console.error("Erro a formatar filtro:", e);
        }
      },

      async removerFiltro(filtro) {
        const result = await swal.fire({
          title: "Eliminar grupo?",
          text: `Tens a certeza que queres eliminar "${filtro.nome}"?`,
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Eliminar",
          cancelButtonText: "Cancelar",
          confirmButtonColor: "#ff825d",
          cancelButtonColor: "#f7f4f1",
        });
        if (!result.value) return;
        try {
          await filtrosService.deletar(filtro.id);
          this.filtros_utilizador = this.filtros_utilizador.filter(
            (f) => f.id !== filtro.id,
          );
          this.$notify({
            type: "success",
            title: "Eliminado",
            message: "Grupo removido.",
          });
        } catch {
          this.$notify({
            type: "danger",
            title: "Erro",
            message: "Não foi possível remover o grupo.",
          });
        }
      },

      verClientes(filtro) {
        this.$router.push({
          path: "/clientes/lista-clientes",
          query: { grupo: filtro.id },
        });
      },
      verInsights(filtro) {
        this.$router.push({ path: "/insights", query: { grupo: filtro.id } });
      },
      enviarCampanha(filtro) {
        this.$router.push({
          path: "/campanhas/criar",
          query: { segmento_id: filtro.id },
        });
      },
      abrirCriarFiltro() {
        this.$router.push({
          path: "/clientes/lista-clientes",
          query: { filtroAberto: true },
        });
      },

      async inicio() {
        try {
          const filtrosBD = await filtrosService.listar();
          const promises = filtrosBD.map(async (f) => {
            const data = await filtrosService.getCount(f.id);
            return {
              id: f.id,
              nome: f.nome,
              filtro_json: f.filtro_json,
              descricao: f.descricao,
              clientes: data.total,
            };
          });
          this.filtros_utilizador = await Promise.all(promises);
          this.rendered = true;
        } catch (err) {
          console.error("Erro ao carregar filtros:", err);
          if (err.response?.status === 403) {
            localStorage.removeItem("tokenAbitue");
            this.$router.push("/login");
          }
        }
      },
    },
    async mounted() {
      await this.inicio();
    },
  };
</script>

<style scoped>
  .seg-root {
    padding: 28px 28px 48px;
    font-family: "DM Sans", "Outfit", system-ui, sans-serif;
    min-height: 100vh;
    background: #f8f6f3;
  }

  /* HEADER */
  .seg-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 28px;
    gap: 16px;
    flex-wrap: wrap;
  }
  .seg-header-left {
    display: flex;
    align-items: center;
    gap: 14px;
  }
  .seg-header-icon {
    width: 44px;
    height: 44px;
    flex-shrink: 0;
    background: #ff825d;
    border-radius: 13px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    box-shadow: 0 4px 14px rgba(255, 130, 93, 0.3);
  }
  .seg-title {
    font-size: 20px;
    font-weight: 800;
    color: #1a1210;
    margin: 0;
    letter-spacing: -0.4px;
  }
  .seg-sub {
    font-size: 13px;
    color: #b0a8a0;
    margin: 3px 0 0;
  }

  .seg-create-btn {
    display: inline-flex;
    align-items: center;
    gap: 7px;
    padding: 10px 18px;
    background: #ff825d;
    color: #fff;
    border: none;
    border-radius: 11px;
    font-size: 13.5px;
    font-weight: 600;
    cursor: pointer;
    box-shadow: 0 2px 8px rgba(255, 130, 93, 0.3);
    transition: all 0.15s;
    font-family: inherit;
    white-space: nowrap;
  }
  .seg-create-btn:hover {
    background: #e86b45;
    transform: translateY(-1px);
    box-shadow: 0 4px 14px rgba(255, 130, 93, 0.4);
  }

  /* EMPTY */
  .seg-empty {
    text-align: center;
    padding: 80px 20px;
    color: #b0a8a0;
  }
  .seg-empty-icon {
    width: 72px;
    height: 72px;
    border-radius: 20px;
    background: #f5f2ef;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 20px;
    color: #c8c0b8;
  }
  .seg-empty h3 {
    font-size: 18px;
    font-weight: 700;
    color: #5a534f;
    margin-bottom: 8px;
  }
  .seg-empty p {
    font-size: 14px;
    color: #b0a8a0;
    margin-bottom: 24px;
  }

  /* GRID */
  .seg-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 16px;
  }

  @media (max-width: 1200px) {
    .seg-grid {
      grid-template-columns: repeat(3, 1fr);
    }
  }
  @media (max-width: 860px) {
    .seg-grid {
      grid-template-columns: repeat(2, 1fr);
    }
  }

  /* CARD */
  .seg-card {
    background: #fff;
    border: 1.5px solid #f0ece8;
    border-radius: 16px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04), 0 4px 14px rgba(0, 0, 0, 0.05);
    display: flex;
    flex-direction: column;
    transition: box-shadow 0.15s, transform 0.15s;
    overflow: hidden;
  }
  .seg-card:hover {
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.06), 0 12px 32px rgba(0, 0, 0, 0.08);
    transform: translateY(-2px);
  }

  .seg-card-top {
    padding: 18px 18px 14px;
    flex: 1;
  }

  .seg-card-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 10px;
    margin-bottom: 12px;
  }
  .seg-card-name {
    font-size: 15px;
    font-weight: 700;
    color: #1a1210;
    margin: 0;
    line-height: 1.3;
    letter-spacing: -0.2px;
  }

  .seg-delete-btn {
    background: none;
    border: none;
    cursor: pointer;
    color: #d0c8c0;
    padding: 4px;
    border-radius: 6px;
    display: flex;
    align-items: center;
    transition: all 0.12s;
    flex-shrink: 0;
    opacity: 0;
  }
  .seg-card:hover .seg-delete-btn {
    opacity: 1;
  }
  .seg-delete-btn:hover {
    color: #e05a3a;
    background: #fef0ef;
  }

  /* Count */
  .seg-count-row {
    display: flex;
    align-items: baseline;
    gap: 6px;
    margin-bottom: 8px;
  }
  .seg-count {
    font-size: 34px;
    font-weight: 800;
    color: #ff825d;
    letter-spacing: -1px;
    line-height: 1;
  }
  .seg-count-label {
    font-size: 13px;
    color: #b0a8a0;
    font-weight: 500;
  }

  /* Desc */
  .seg-desc {
    font-size: 13px;
    color: #8a857e;
    margin: 0 0 12px;
    line-height: 1.5;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  /* Chips preview */
  .seg-chips {
    display: flex;
    flex-wrap: wrap;
    gap: 5px;
  }
  .seg-chip {
    display: inline-flex;
    align-items: center;
    padding: 3px 9px;
    background: #f5f2ef;
    border: 1px solid #ece8e4;
    border-radius: 20px;
    font-size: 11.5px;
    font-weight: 500;
    color: #6b6460;
  }
  .seg-chip-more {
    background: #fff0eb;
    border-color: #ffd8c8;
    color: #c04820;
    font-weight: 700;
  }

  .seg-card-divider {
    height: 1px;
    background: #f5f2ef;
  }

  /* Actions */
  .seg-card-actions {
    display: flex;
    padding: 8px 10px;
    gap: 2px;
    flex-wrap: wrap; /* ← permite quebrar linha */
  }

  .seg-action {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 5px;
    padding: 8px 4px;
    border: none;
    background: none;
    cursor: pointer;
    font-size: 12px;
    font-weight: 600;
    color: #8a857e;
    border-radius: 9px;
    transition: all 0.12s;
    font-family: inherit;
    white-space: nowrap;
    min-width: 0; /* ← permite encolher */
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .seg-action:hover {
    background: #f7f4f1;
    color: #1a1210;
  }
  .seg-action-details:hover {
    background: #fff0eb;
    color: #ff825d;
  }

  /* MODAL */
  .seg-overlay {
    position: fixed;
    inset: 0;
    background: rgba(15, 10, 8, 0.45);
    backdrop-filter: blur(6px);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1200;
    padding: 16px;
  }
  .seg-modal {
    background: #fff;
    border-radius: 18px;
    width: 100%;
    max-width: 520px;
    max-height: 80vh;
    display: flex;
    flex-direction: column;
    box-shadow: 0 24px 80px rgba(0, 0, 0, 0.2);
    overflow: hidden;
  }
  .seg-modal-head {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    padding: 22px 24px 18px;
    border-bottom: 1px solid #f5f2ef;
    gap: 14px;
  }
  .seg-modal-title {
    font-size: 17px;
    font-weight: 800;
    color: #1a1210;
    letter-spacing: -0.3px;
  }
  .seg-modal-sub {
    font-size: 13px;
    color: #b0a8a0;
    margin-top: 3px;
  }
  .seg-modal-close {
    background: #f7f4f1;
    border: none;
    cursor: pointer;
    width: 30px;
    height: 30px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #7a736e;
    transition: all 0.12s;
    flex-shrink: 0;
  }
  .seg-modal-close:hover {
    background: #f0ece8;
    color: #1a1210;
  }

  .seg-modal-body {
    padding: 20px 24px;
    overflow-y: auto;
    flex: 1;
  }
  .seg-modal-section-title {
    font-size: 11px;
    font-weight: 700;
    color: #b0a8a0;
    text-transform: uppercase;
    letter-spacing: 0.07em;
    margin-bottom: 12px;
  }
  .seg-modal-chips {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
  .seg-modal-chip {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 14px;
    background: #faf8f6;
    border: 1px solid #f0ece8;
    border-radius: 10px;
    font-size: 13.5px;
    color: #2a2420;
  }
  .seg-modal-chip svg {
    color: #2dce89;
    flex-shrink: 0;
  }
  .seg-modal-empty {
    text-align: center;
    padding: 24px;
    color: #b0a8a0;
    font-size: 13.5px;
  }

  .seg-modal-foot {
    display: flex;
    gap: 8px;
    justify-content: flex-end;
    padding: 16px 24px;
    border-top: 1px solid #f5f2ef;
  }
  .seg-btn {
    display: inline-flex;
    align-items: center;
    gap: 7px;
    padding: 10px 18px;
    border: none;
    border-radius: 10px;
    font-size: 13.5px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.15s;
    font-family: inherit;
  }
  .seg-btn-ghost {
    background: #f7f4f1;
    color: #5a534f;
  }
  .seg-btn-ghost:hover {
    background: #f0ece8;
  }
  .seg-btn-primary {
    background: #ff825d;
    color: #fff;
    box-shadow: 0 2px 8px rgba(255, 130, 93, 0.3);
  }
  .seg-btn-primary:hover {
    background: #e86b45;
  }

  .seg-fade-enter-active {
    transition: opacity 0.2s;
  }
  .seg-fade-leave-active {
    transition: opacity 0.15s;
  }
  .seg-fade-enter,
  .seg-fade-leave-to {
    opacity: 0;
  }

  @media (max-width: 600px) {
    .seg-root {
      padding: 16px 12px 40px;
    }
    .seg-grid {
      grid-template-columns: 1fr;
    }
    .seg-delete-btn {
      opacity: 1;
    }
  }
</style>
